import { render, staticRenderFns } from "./evidence.vue?vue&type=template&id=20f0e921&"
import script from "./evidence.vue?vue&type=script&lang=js&"
export * from "./evidence.vue?vue&type=script&lang=js&"
import style0 from "./evidence.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports